import ngFileUpload from 'ng-file-upload';

import register from '@kpsys/angularjs-register';
import {FileDataService} from './file.data-service';
import {FileContentDataService} from './file-content.data-service';
import {FileService} from './file.service';
import {FileUploadService} from './file-upload.service';


/**
 * @ngdoc module
 * @name portaro.file
 * @module portaro.file
 */
export default register('portaro.file', [ngFileUpload]) // ngFileUpload is used by FileUploadService
    .service(FileContentDataService.serviceName, FileContentDataService)
    .service(FileDataService.serviceName, FileDataService)
    .service(FileUploadService.serviceName, FileUploadService)
    .service(FileService.serviceName, FileService)
    .name();